export class PaginationMeta {
  constructor({ currentPage, totalPages, totalItems, pageSize }) {
    this.currentPage = currentPage || 1;
    this.totalPages = totalPages || 1;
    this.totalItems = totalItems || 0;
    this.pageSize = pageSize || 10;
  }
}
